// Happy Hearts palette from Boris's ACCESS prototype (Claude Design project
// 9b17f347: register.css :root + tokens.css). These are the prototype's raw
// values, applied to rebrand the web-reg flow to Boris's Happy Hearts design
// (Daniel, 2026-07-07). Font stays the app's Lato (Boris's SF Compact Rounded
// is not licensed here). Kept under this name for back-compat with the screener
// components that already import `BorisScreener`.
export const BorisScreener = {
  // surfaces
  sand: '#F5F2EE', // app background (--cream)
  sand2: '#F2EDE4', // secondary sand (--cream-2)
  white: '#ffffff',
  // ink / text
  ink: '#1C1F21', // near-black text / selected fill
  inkSoft: '#5C5F61', // muted subhead (--ink-soft)
  inkFaint: 'rgba(28,31,33,0.45)', // faint mono counter (--ink-faint)
  cream: '#F4EFE7', // label color on a selected (ink-filled) option
  // borders
  line: 'rgba(28,31,33,0.12)', // default border (--line)
  lineStrong: 'rgba(28,31,33,0.22)', // hover border (--line-strong)
  // brand (coral) — accent only: checkbox fill, logo, selected marks
  coral: '#B0361E', // brand accent (hh-coral-9)
  coralPressed: '#A0260C', // pressed (hh-coral-10)
  // primary action button (Boris .dsb-primary — dark green, not coral)
  btnPrimary: '#123F39', // dsb-primary background
  btnPrimaryHover: '#17544D', // dsb-primary hover/active
  // progress dashes (gold)
  dashTrack: '#F0E0C5', // upcoming dash (gold-5)
  dashFill: '#C7A472', // done / current dash (gold-8)
  // accent tints (info/disclosure cards etc.)
  lime: '#F7FBC2',
  blue: '#D0D5FF',
  green: '#C8E9CE',
  pink: '#F1D4F2',
  bad: '#C2532E',
};
